<template>
  <div
    class="msg-qdxml"
    ref="msgQdxml"
  >
    <div ref="xmlBox" v-html="html" :title="data.brief||''"></div>
  </div>
</template>

<script>
import axios from 'axios';
import { translateXMLToVirtualDOM, parseMsgXML, parseMsgContent } from './xmlParser/transfer';
import { render } from './xmlParser/render';
import { bindXMLEvent } from './xmlParser/bindXMLEvent';
import { IMSDK, SDKUtils } from '@/imsdk/index.ts';
import bindlLinkClick from '@/utils/bindlLinkClick';
import globalWin from '@/utils/globalWin';
import { getScrollBottom, scrollLimit } from '@/utils/scroll.ts';
import { GET_QUICK_ORDER_CARD } from '@/utils/api';
import qs from 'qs';

export default {
  props: {
    data: Object,
  },
  data() {
    return {
      html: '',
    };
  },
  computed: {
  },
  async mounted() {
    this.initDelegations();
    if (this.data.content) {
      this.transferXml(this.data.content);
      this.onLoad();
      return;
    }

    if (!this.data.path) {
      this.html = '<span class="xml-data-err">[获取消息内容异常]</span>';
      return;
    }

    if (this.data.compressed) {
      // 如果是SDK通路的被压缩的长文本
      let content;
      try {
        content = await SDKUtils.downloadAndParseLongText(this.data, 'xml');
      } catch (ex) {}
      if (content) {
        this.transferXml(content);
      } else {
        this.html = '<span class="xml-data-err">[获取消息内容异常]</span>';
      }
    } else {
      const resPath = await SDKUtils.getDownloadUrl(this.data, IMSDK.OBJTYPES.OBJ_LONGTEXT);
      if (resPath) {
        axios
          .get(resPath)
          .then((response) => {
            if (response.status === 200) {
              this.transferXml(response.data);
            } else {
              this.html = '<span class="xml-data-err">[获取消息内容异常]</span>';
            }
          })
          .catch(() => {
            this.html = '<span class="xml-data-err">[获取消息内容异常]</span>';
          });
      } else {
        this.html = '<span class="xml-data-err">[获取消息内容异常]</span>';
      }
    }

    this.onLoad();
  },
  methods: {
    transferXml(xml) {
      const cls = this.getExtendCls(xml);
      this.getExtendCls(cls);
      const spcCls = this.getSpecialCls(cls);
      const [xmlStr, scriptStr] = parseMsgContent(xml);
      const xmlDom = parseMsgXML(xmlStr);
      console.log('[xmlDom]', xmlDom);
      const VDOM = translateXMLToVirtualDOM(xmlDom);
      const HTML = render(VDOM, { dir: `webim-xml ${spcCls}` });
      this.html = HTML;
      // 绑定xml的默认处理事件
      this.$nextTick(() => {
        bindXMLEvent(this.$refs.xmlBox, VDOM, scriptStr, {
          // 电商上下文
          ...this.getEcCardCtx(),
        });
      });
    },

    initDelegations() {
      bindlLinkClick(this.$refs.msgQdxml, 'a');
    },

    /**
     * 获取消息上和C侧约定的样式class
     */
    getExtendCls(xml) {
      const reg = /<msg.+?extClass="([\w-]+)".*?>/i;
      const mrs = xml.match(reg);
      if (mrs && mrs[1]) {
        return mrs[1];
      }
      return '';
    },

    /**
     * 根据输入的class，获取特殊的样式
     */
    getSpecialCls(cls) {
      if (!cls) {
        return '';
      }
      const noShadowCls = [
        'webim-kf-change', // webim切换客服
      ];
      if (noShadowCls.indexOf(cls) > -1) {
        return 'no-shadow';
      }
      return '';
    },

    onLoad() {
      // 如果极短时间内有多个xml出现，就不判断位置了，直接滚动到底部
      if ((globalWin.LAST_SHOW_XML_TIME && (Date.now() - globalWin.LAST_SHOW_XML_TIME < 300))
        || getScrollBottom() < scrollLimit) {
        globalWin.scrollToBottom(true, 500);
        globalWin.LAST_SHOW_XML_TIME = Date.now();
      }
    },

    // 电商卡片script执行上下文
    getEcCardCtx() {
      const urlParams = qs.parse(window.location.search, { ignoreQueryPrefix: true });

      return {
        __onlineGoodsObj: {
          scene: Number(urlParams.scene) || null,
          sceneArgs: urlParams.sceneArgs || null,
          channelType: 4, // webim 写死
          infoUrl: GET_QUICK_ORDER_CARD,
        },
      };
    },
  },
};
</script>

<style lang="less" scoped>
.msg-qdxml {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  min-width: 230px; // 误删，否则会造成导航显示异常，所有的xml消息外层，最好自己设置宽度
  text-align: left;

  // 隐藏通用xml的阴影
  ::v-deep .no-shadow{
    .msg-xml-container{
      box-shadow: none;
    }
  }

  ::v-deep a{
    text-decoration: none;
  }

  ::v-deep .msg-xml-container {
    * {
      box-sizing: border-box;
    }

    display: block;
    color: #000;
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    line-height: 1.4285;
    max-width: 340px;
    overflow: hidden; // xml消息要显示圆角就需要加这个。如果后续什么功能和这个样式冲突，要仔细研究下怎么处理。

    .msg-xml-divider {
        background-color: #ebedf2;
    }

    // 非展开时，因此子菜单
    .msg-xml-fold {
      cursor: pointer;

      >:first-child {
        display: block;
        position: relative;

        &::after {
          position: absolute;
          top: 50%;
          right: 16px;
          margin-top: -6px;
          content: ' ';
          display: block;
          width: 12px;
          height: 12px;
          background: url('~./assets/arrow_down.svg') no-repeat center;
          opacity: 0.5;
          transition: all 0.2s;
        }
      }
      >:last-child {
        height: 0;
        overflow: hidden;
      }

      &.expand {
        >:first-child {
          &::after {
            transform: perspective(100px) rotateX(180deg);
          }
        }
        >:last-child {
          height: auto;
          overflow: visible;
        }
      }
    }
  }

  ::v-deep .xml-data-err{
    display: block;
    text-align: center;
    padding: 10px 15px;
    color: #a1abc2;
    font-size: 12px;
  }
  &.pc.pc-not-frame {
    ::v-deep .xml-data-err{
      padding: 12px;
      font-size: 13px;
    }
  }
}
</style>
